import { useEffect, useMemo, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useAccountsStore, useCardsStore, useDictionariesStore, useStatusStore } from '@lib/store';
import { cn, RoutePaths } from '@shared/utils';
import { Header, HeaderMobile } from '@widgets';
import { Spinner } from '@shared/widgets';

export const PageLayout = () => {
  const params = useParams<{ id: string }>();

  const accountsStore = useAccountsStore();
  const cardsStore = useCardsStore();
  const statusStore = useStatusStore();
  const dictionariesStore = useDictionariesStore();

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      await Promise.allSettled([accountsStore.getAccounts(), cardsStore.getCards(), statusStore.getStatus(), dictionariesStore.getDictionaries()]);
      setLoading(false);
    })();
  }, []);

  const menu = useMemo(
    () => [
      { link: RoutePaths.dashboard.onNavigate(), name: 'Home' },
      { link: RoutePaths.accounts.onNavigate(params.id || accountsStore.data?.[0]?.Id || ''), name: 'Accounts' },
      { link: RoutePaths.cards.onNavigate(), name: 'Cards' },
      { link: RoutePaths.payments.onNavigate(), name: 'Payments' },
      { link: RoutePaths.contactUs.onNavigate(), name: 'Contact us' },
    ],
    [accountsStore.data],
  );
  if (loading)
    return (
      <main className='flex h-full w-full flex-col items-center justify-center'>
        <Spinner />
      </main>
    );
  return (
    <main className='relative pb-12'>
      <HeaderMobile className='hidden max-[769px]:block' menu={menu} />
      <Header className='max-[769px]:hidden' menu={menu} />
      <div className={cn('min-h-[calc(100vh-80px)] overflow-hidden pt-20', 'max-md:pt-16')}>
        <Outlet />
      </div>
    </main>
  );
};
